import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  background: #06512f;
  min-height: var(--footer-height);
  height: var(--footer-height);
  color: white;
  display: flex;
  align-items: center;
  padding: 0 60px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 0 16px;
    justify-content: center;
  }
`

export const MobileWrapper = styled.div`
  background: #06512f;
  height: var(--navbar-height);
  min-height: var(--navbar-height);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  padding-top: calc(
    env(safe-area-inset-top) + 8px
  ); /* Safe area + 8px breathing room: keeps nav content in the bottom
        footer-height band, clear of the notch (FIR-7616) */
`

export const MobileNavLeft = styled.div`
  display: flex;
  align-items: center;
`

export const MobileNavContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--footer-height);
  width: 100%;
`

export const LogoImg = styled.img`
  margin-right: 40px;
`
